import { FC, Fragment } from 'react'
import {
  List,
  CardContent,
  Card,
  Grid,
  Divider,
  Typography,
} from '@mui/material'
import { TabsEnums, SlipsScreenType } from '../../../components'
import { ListItemComponent } from './ListItemComponent'
import { ItemEntryDetail } from '../../../services/slips'

import { TitleActionBarComponent } from './TitleActionBarComponent'
import { Bill } from 'src/services'

interface OutItemComponentProps {
  data: ItemEntryDetail[]
  separatorHeight: number
  billId: number
  billType: string
  screenType: SlipsScreenType
  onClickViewPDF: (
    showRate: boolean | null,
    title?: string,
    challanId?: number,
    showOnlyGoodValue?: boolean
  ) => void
  checked: boolean
  selectTab?: (index: number) => void
  account?: Bill
  onItemDoubleClick?: (itemName: string) => void
  onSlipsEntriesUpdated?: () => void
}

export const OutItemComponent: FC<OutItemComponentProps> = ({
  data,
  separatorHeight,
  billId,
  screenType,
  billType,
  onClickViewPDF,
  checked,
  selectTab,
  account,
  onItemDoubleClick,
  onSlipsEntriesUpdated,
}) => {
  return (
    <Fragment>
      {data && data.length > 0 && (
        <Fragment>
          <Divider />
          <Grid
            id="properties_name"
            container
            spacing={0}
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              minHeight: '4vh',
              pl: 2,
              pr: 2,
              backgroundColor: '#f9f9f9',
              fontWeight: 'bold',
              position: 'sticky',
              top: 0,
              zIndex: 997,
            }}
          >
            <Grid xs={3} sx={{ pl: 4 }}>
              Item Name
            </Grid>
            <Grid xs={2}>Entry Time</Grid>
            <Grid xs={2} sx={{textAlign:'right', pr:4}}>Rate</Grid>
            <Grid xs={2}>
              <Typography fontWeight={'bold'} pl={4}>
                Quantity
              </Typography>
            </Grid>
            <Grid xs={2}>Entry Type</Grid>
            <Grid xs={1} sx={{ paddingLeft: 4 }}>
              Actions
            </Grid>
          </Grid>
          {data &&
            data.map((items, index) => {
              return (
                <Fragment key={index}>
                  {' '}
                  <Divider />
                  <TitleActionBarComponent
                    data={items}
                    onClickViewPDF={onClickViewPDF}
                    screenType={screenType}
                    billType={billType}
                    account={account}
                  />
                  <List
                    id="entries_list_items_per_date"
                    sx={{
                      width: '100%',
                      bgcolor: 'white',
                      p: 0,
                      m: 0,
                    }}
                    component="div"
                    aria-labelledby="subheader"
                    key={index}
                  >
                    {items.itemEntries &&
                      items.itemEntries.map((item, i) => {
                        return (
                          <Fragment key={i}>
                            {(!checked || item.id >= 0) && (
                              <Fragment key={i}>
                                <Divider />
                                <ListItemComponent
                                  challan={items}
                                  item={item}
                                  key={i}
                                  componentName={TabsEnums.Out}
                                  billId={billId}
                                  screenType={screenType}
                                  accountType={account?.accountType}
                                  onItemDoubleClick={onItemDoubleClick}
                                  onSlipsEntriesUpdated={onSlipsEntriesUpdated}
                                />
                              </Fragment>
                            )}
                          </Fragment>
                        )
                      })}
                  </List>
                </Fragment>
              )
            })}
        </Fragment>
      )}
    </Fragment>
  )
}
